export const useAddressButtonTitle = 'use this address';
export const nearbyAddressesTitle = 'nearby addresses';
export const cardTitle = 'Select a location.';
export const selectPropertyHelper = 'Select a location on the map to get started.';
